import {Box, Card, Divider, Typography} from '@material-ui/core';
import React from 'react';
import {IFarmInputQuote, ISupplierUserProfile} from 'constants/interfaces';
import {Skeleton} from '@material-ui/lab';
import moment from 'moment';
import {_NumberWithSpaces} from 'constants/index';

export function QuoteDetailCard(props: {
  quote?: IFarmInputQuote;
  user: ISupplierUserProfile;
  isLoading?: boolean;
}) {
  if (props.isLoading)
    return <Skeleton variant="rect" height={200} style={{borderRadius: 8}} />;
  if (!props.quote) return null;
  const {quote, user} = props;
  const formatDate = (date: Date): string => {
    return moment(date).format('YYYY-MM-DD');
  };
  const quoteDate = (quote: IFarmInputQuote) => {
    return formatDate(new Date(parseInt(quote.updateDate)));
  };
  const productTotal = () => {
    if (!props.quote) return '';
    return props.quote.lineItems.reduce(
      (total, line) => total + line.price * line.quantity,
      0,
    );
  };
  return (
    <Card className="farmer-detail-card" variant="outlined">
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Date</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {quoteDate(quote)}
          </Typography>
        </Box>
      </Box>
      <Divider />
      {user.isAdmin && (
        <>
          <Box className="row">
            <Box className="title-container">
              <Typography variant="subtitle2">Depot</Typography>
            </Box>
            <Box className="value-container">
              <Typography variant="body2" color="textSecondary">
                {quote?.depot?.name}
              </Typography>
            </Box>
          </Box>
          <Divider />
        </>
      )}
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Order Status</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {quote?.formattedState}
          </Typography>
        </Box>
      </Box>
      <Divider />
      {/* <Box className="row">*/}
      {/*  <Box className="title-container">*/}
      {/*    <Typography variant="subtitle2">Delivery Type</Typography>*/}
      {/*  </Box>*/}
      {/*  <Box className="value-container">*/}
      {/*    <Typography variant="body2" color="textSecondary">*/}
      {/*      {quote?.deliveryType}*/}
      {/*    </Typography>*/}
      {/*  </Box>*/}
      {/* </Box>*/}
      {/* <Divider />*/}
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Item Count</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            {quote?.lineItems.length}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Products</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            R {_NumberWithSpaces(productTotal())}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Logistics</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            R {_NumberWithSpaces(quote?.logisticsCost || 0)}
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box className="row">
        <Box className="title-container">
          <Typography variant="subtitle2">Total</Typography>
        </Box>
        <Box className="value-container">
          <Typography variant="body2" color="textSecondary">
            R {_NumberWithSpaces(quote?.total)}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
}
